import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type {
  TPostPartnerUBODocumentFromPersonaParams,
  TPostPartnerUBODocumentFromPersonaResponse,
} from "./postPartnerUBODocumentFromPersona.schema";

export const postPartnerUBODocumentFromPersona = (axios: IAxiosInstance) => {
  return async (
    params: TPostPartnerUBODocumentFromPersonaParams
  ): Promise<TPostPartnerUBODocumentFromPersonaResponse> => {
    const { whiteLabelID, persona_inquiry_id, first_name, last_name } = params;
    const response = await axios.noRetry.post<
      IApiResponse<TPostPartnerUBODocumentFromPersonaResponse>
    >(`/api/partners/${whiteLabelID}/ubo-document-from-persona`, {
      persona_inquiry_id,
      first_name,
      last_name,
    });
    const resData = response.data;
    if (resData?.data?.success) {
      return {
        success: true,
        message: resData.data?.message ?? "",
      };
    }
    throw new Error("Something went wrong");
  };
};
